import React, { useState } from "react";
import { useAddRestaurantStyles } from "../../Util/CSS/AddRestaurant/AddRestaurant";
import AddRestaurantComp from "./AddRestaurantComp";
import LoadingScreen from "../../Shared/LoadingScreen";
import OpenSnackbar from "../../Shared/OpenSnackbar";
import { useContext } from "react";
import { AuthContext } from "../../Context/Auth";
import { useDispatch } from "react-redux";
import { RestaurantAction } from "../../Store/Reducers/Restaurant-reducer";
import { log } from "react-modal/lib/helpers/ariaAppHider";
import { createNextState } from "@reduxjs/toolkit";

const AddRestaurant = ({ modalClose, NewReqDetails, restData }) => {
  const dispatch = useDispatch();
  const classes = useAddRestaurantStyles();
  const [uuid, setUuid] = useState("");
  const [restaurantData, setRestaurantData] = useState({
    name: NewReqDetails ? NewReqDetails.RestName : "",
    email_id: NewReqDetails ? NewReqDetails.emailId : "",
    slug: "",

    service_type: {
      delivery: false,
      pickup: false,
      pay_on_delivery: false,
      pay_on_pickup: false,
    },
    type: [],
    payment_types: {
      pay_by_cash: false,
      pay_by_card: false,
    },
    activation_status: false,
  });
  const [errors, setErrors] = useState({
    name: false,
    slug: false,
    email_id: false,
    btnActive: false,
  });
  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarDetails, setSnackbarDetails] = useState({
    message: "",
    type: "",
  });

  const handleSnackbarOpen = (message, type) => {
    let obj = {
      message,
      type,
    };
    setSnackbarDetails(obj);
    setSnackbarOpen(true);
  };

  const validate = (name, value) => {
    const emailRegex =
      /^([a-z\d\.-]+)@([a-z\d-]+)\.([a-z]{2,8})(\.[a-z]{2,8})?$/;
    let errs = errors;
    switch (name) {
      case "name":
        if (String(value).length < 2) {
          errs.name = true;
        } else {
          errs.name = false;
        }
        break;
      case "slug":
        let regex = /^[a-z0-9_-]+$/i;
        if (value.length === 0) {
          setRestaurantData({ ...restaurantData, slug: value });
          errs.slug = false;
        } else if (regex.test(value)) {
          if (String(value).length < 1) {
            errs.slug = true;
          } else {
            errs.slug = false;
          }
          setRestaurantData({ ...restaurantData, slug: value });
        } else {
          return;
        }
        break;
      case "email_id":
        if (!emailRegex.test(value)) {
          errs.email_id = true;
        } else if (value.length === 0) {
          errs.email_id = true;
        } else {
          errs.email_id = false;
        }
        break;
      default:
        break;
    }
    if (!errs.email_id && !errs.slug && !errs.name) {
      errs.btnActive = true;
    }
    setErrors(errs);
  };

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    if (name === "slug") {
      validate(name, value);
    } else {
      setRestaurantData({ ...restaurantData, [name]: value });
      validate(name, value);
    }
  };

  const handleSwitchChange = (event, key) => {
    let { checked } = event.target;
    let obj = restaurantData;
    if (
      key === "delivery" ||
      key === "pickup" ||
      key === "pay_by_cash" ||
      key === "pay_by_card"
    ) {
      if (key === "delivery") {
        obj.service_type.delivery = event.target.checked;
        if (checked) {
          obj.type.push("delivery");
        } else {
          obj.type.pop("delivery");
        }
      }
      if (key === "pickup") {
        obj.service_type.pickup = event.target.checked;
        if (checked) {
          obj.type.push("pickup");
        } else {
          obj.type.pop("pickup");
        }
      }
      if (key === "pay_by_cash") {
        obj.payment_types.pay_by_cash = event.target.checked;
      }
      if (key === "pay_by_card") {
        obj.payment_types.pay_by_card = event.target.checked;
      }
    }
    setRestaurantData({ ...obj });
  };

  const { user } = useContext(AuthContext);
  const handleAddRestaurant = async () => {
    if (errors.email_id || errors.name || errors.slug) {
      handleSnackbarOpen("Please fill the required fields", "errorDark");
      return;
    }

    if (
      restaurantData.service_type.delivery === false &&
      restaurantData.service_type.pickup === false
    ) {
      handleSnackbarOpen("Please select atleast one service", "errorDark");
      setLoading(false);
      return;
    }
    if (
      restaurantData.payment_types.pay_by_cash === false &&
      restaurantData.payment_types.pay_by_card === false
    ) {
      handleSnackbarOpen("Please select atleast one feature", "errorDark");
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      let res = await fetch(`${process.env.REACT_APP_API_URL}restaurant`, {
        method: "POST",
        body: JSON.stringify(restaurantData),
        headers: {
          Authorization: user,
        },
      });
      let data = await res.json();
      console.log("res data>>", data);
      setRestaurantData({
        ...restaurantData,
        ["apikey"]: data.restaurant_api_key,
      });
      if (data.restaurant_uuid) {
        const newRestaurant = {
          ...restaurantData,
          id: data.restaurant_uuid,
          totalOrders: "0",
          readableId: data.readable_id,
          restaurantName: restaurantData.name,
          status: false,
          createdAt: Date.now(),
          contactNumber: "+1 XXXX XXX XXX",
        };
        let newRestList = [newRestaurant, ...restData];
        dispatch(RestaurantAction.addNewRestaurant(newRestList));
        setUuid(data.restaurant_uuid);
        setLoading(false);
        // modalClose();
        setOpen(true);
      } else {
        handleSnackbarOpen(data.error, "errorDark");
      }
    } catch (err) {
      if (!err.status || err.status === 401) {
        window.location.reload(false);
      }
      setLoading(false);
      handleSnackbarOpen("Something went wrong😥", "errorDark");
    } finally {
      setLoading(false);
    }
  };
  const handleSaveModalClose = () => {
    modalClose();
    setOpen(false);
  };
  return (
    <>
      {loading ? (
        <LoadingScreen loading={loading} />
      ) : (
        <>
          <AddRestaurantComp
            classes={classes}
            open={open}
            handleAddRestaurant={handleAddRestaurant}
            handleSaveModalClose={handleSaveModalClose}
            handleTextChange={handleTextChange}
            handleSwitchChange={handleSwitchChange}
            errors={errors}
            restaurantData={restaurantData}
            uuid={uuid}
          />
          {snackbarOpen && (
            <OpenSnackbar
              message={snackbarDetails.message}
              type={snackbarDetails.type}
              open={snackbarOpen}
              setOpen={setSnackbarOpen}
              vertical="bottom"
              horizontal="left"
            />
          )}
        </>
      )}
    </>
  );
};

export default AddRestaurant;
